module.exports = __webpack_public_path__ + "img/03_no.a51329fd.svg";